import RefreshAuthStateCustomizer from './refresh-auth-state';
import PasswordResetClassic from './password-expired/classic';
import PasswordResetOieAnetCustomizer from './password-expired/oie/anet';
import PasswordResetOieNonAnetCustomizer from './password-expired/oie/non-anet';
import PrimaryAuthOieCustomizer from './primary-auth/oie';
import PrimaryAuthClassicCustomizer from './primary-auth/classic';
import BaseCustomizer from './base';
import CommonCustomizer from './common';
import GranularConsentCustomizer from './granular-consent';
import FactorEnrollClassicCustomizer from './factors/enroll-factors/classic';
import FactorEnrollOieCustomizer from './factors/enroll-factors/oie';
import ChallengeFactorOieCustomizer from './factors/challenge-factors/oie';
import TerminalCustomizer from './terminal';
import AuthenticatorAppEnrollClassic from './authenticator-app-enroll/classic';
import OktaVerifyClassicCustomizer from './okta-verify-enroll/classic';
import EnrollPhoneFactorCustomizer from './enroll-phone/classic';
import SuccessRedirect from './success-redirect';
import AmplitudeUtils from '../utils/amplitude-utils';
import MfaVerifyClassicCustomizer from './mfa-verify/classic';
import EnrollPollQrCodeCustomizer from './okta-verify-enroll-oie/enroll-poll/qrcode';
import EnrollPollSmsCustomizer from './okta-verify-enroll-oie/enroll-poll/sms';
import SelectEnrollmentChannelCustomizer from './okta-verify-enroll-oie/select-enrollment-channel';
import EnrollmentChannelDataCustomizer from './okta-verify-enroll-oie/enrollment-channel-data';
import EnrollPhoneFactorCustomizerOie from './enroll-phone/oie';
import ChallengeAuthenticatorOieCustomizer from './mfa-verify/oie/challenge-authenticator';
import AuthenticatorVerificationDataOieCustomizer from './mfa-verify/oie/authenticator-verification-data';
import { unhideWidget } from '../utils/widget-facade';
import EnrollAuthenticatorOieCustomizer from './authenticator-app-enroll-oie/enroll-authenticator';
import MfaVerifyPasscodePhoneOieCustomizer from './mfa-verify/oie/mfa-verify-passcode-phone';
import MfaVerifyPasscodeEmailCustomizer from './mfa-verify/oie/mfa-verify-passcode-email';
import ChallengePollOieCustomizer from './mfa-verify/oie/challenge-poll';
import EnrollQuestionClassic from './enroll-question/classic';
import EnrollQuestionOie from './enroll-question/oie';
import MfaVerifyQuestionOie from './mfa-verify/oie/mfa-verify-question';
import { AppSettings } from '../utils/app-settings';
import EnrollPollMobileSameDeviceCustomizer from './okta-verify-enroll-oie/enroll-poll/mobile-same-device';
import PasswordResetInitCustomizer from './password-reset/oie/password-reset-init';
import PasswordResetCompletionCustomizer from './password-reset/oie/password-reset-completion';


export interface CustomizeControllerArgs {
  requestContext: any;
  context: any;
  settings: AppSettings;
  config: any;
  oktaSignIn: any;
}

function getCustomizers(initArgs: CustomizeControllerArgs): Record<string, BaseCustomizer> {
  const commonCustomizer = new CommonCustomizer(initArgs);
  const primaryAuthOieCustomizer = new PrimaryAuthOieCustomizer(initArgs);
  const primaryAuthClassicCustomizer = new PrimaryAuthClassicCustomizer(initArgs);
  const passwordResetClassicCustomizer = new PasswordResetClassic(initArgs);
  const granularConsentCustomizer = new GranularConsentCustomizer(initArgs);
  const passwordResetOieAnetCustomizer = new PasswordResetOieAnetCustomizer(initArgs);
  const passwordResetOieNonAnetCustomizer = new PasswordResetOieNonAnetCustomizer(initArgs);
  const factorEnrollClassicCustomizer = new FactorEnrollClassicCustomizer(initArgs);
  const factorEnrollOieCustomizer = new FactorEnrollOieCustomizer(initArgs);
  const terminalCustomizer = new TerminalCustomizer(initArgs);
  const challengeFactorOieCustomizer = new ChallengeFactorOieCustomizer(initArgs);
  const enrollTotpClassicCustomizer = new AuthenticatorAppEnrollClassic(initArgs);
  const activatePushClassicCustomizer = new OktaVerifyClassicCustomizer(initArgs);
  const enrollPhoneFactorCustomizer = new EnrollPhoneFactorCustomizer(initArgs);
  const refreshAuthStateCustomizer = new RefreshAuthStateCustomizer(initArgs);
  const mfaVerifyClassicCustomizer = new MfaVerifyClassicCustomizer(initArgs);
  const enrollPollQrCodeCustomizer = new EnrollPollQrCodeCustomizer(initArgs);
  const enrollPollSmsCustomizer = new EnrollPollSmsCustomizer(initArgs);
  const enrollPollMobileSameDeviceCustomizer = new EnrollPollMobileSameDeviceCustomizer(initArgs);
  const selectEnrollmentChannelCustomizer = new SelectEnrollmentChannelCustomizer(initArgs);
  const enrollmentChannelDataCustomizer = new EnrollmentChannelDataCustomizer(initArgs);
  const enrollPhoneFactorCustomizerOie = new EnrollPhoneFactorCustomizerOie(initArgs);
  const enrollAuthenticatorOieCustomizer = new EnrollAuthenticatorOieCustomizer(initArgs);
  const challengeAuthenticatorOieCustomizer = new ChallengeAuthenticatorOieCustomizer(initArgs);
  const challengePollOieCustomizer = new ChallengePollOieCustomizer(initArgs);
  const mfaVerifyPasscodePhoneOieCustomizer = new MfaVerifyPasscodePhoneOieCustomizer(initArgs);
  const authenticatorVerificationDataOieCustomizer = new AuthenticatorVerificationDataOieCustomizer(initArgs);
  const mfaVerifyPasscodeEmailCustomizer = new MfaVerifyPasscodeEmailCustomizer(initArgs);
  const successRedirect = new SuccessRedirect(initArgs);
  const enrollQuestionClassic = new EnrollQuestionClassic(initArgs);
  const enrollQuestionOie = new EnrollQuestionOie(initArgs);
  const mfaVerifyQuestionOie = new MfaVerifyQuestionOie(initArgs);
  const passwordResetInitCustomizer = new PasswordResetInitCustomizer(initArgs);
  const passwordResetCompletionCustomizer = new PasswordResetCompletionCustomizer(initArgs);
  return {
    commonCustomizer,
    refreshAuthStateCustomizer,
    primaryAuthOieCustomizer,
    primaryAuthClassicCustomizer,
    passwordResetClassicCustomizer,
    granularConsentCustomizer,
    passwordResetOieAnetCustomizer,
    passwordResetOieNonAnetCustomizer,
    factorEnrollClassicCustomizer,
    factorEnrollOieCustomizer,
    challengeFactorOieCustomizer,
    terminalCustomizer,
    enrollTotpClassicCustomizer,
    activatePushClassicCustomizer,
    mfaVerifyClassicCustomizer,
    successRedirect,
    enrollPhoneFactorCustomizer,
    enrollPollQrCodeCustomizer,
    enrollPollSmsCustomizer,
    enrollPollMobileSameDeviceCustomizer,
    selectEnrollmentChannelCustomizer,
    enrollmentChannelDataCustomizer,
    enrollPhoneFactorCustomizerOie,
    enrollAuthenticatorOieCustomizer,
    challengeAuthenticatorOieCustomizer,
    challengePollOieCustomizer,
    mfaVerifyPasscodePhoneOieCustomizer,
    authenticatorVerificationDataOieCustomizer,
    mfaVerifyPasscodeEmailCustomizer,
    enrollQuestionClassic,
    enrollQuestionOie,
    mfaVerifyQuestionOie,
    passwordResetInitCustomizer,
    passwordResetCompletionCustomizer,
  };
}

export default async function customizeController(initArgs: CustomizeControllerArgs) {
  const customizers = getCustomizers(initArgs);

  for (const customizerName in customizers) {
    const customizer = customizers[customizerName];
    try {
      await customizer.performCustomization();
    }
    catch (e: any) {
      AmplitudeUtils.logCustomizerError({
        customizerName,
        stackTrace: e.stack,
        errorMessage: e.message,
        errorName: e.name,
        ...initArgs.context,
      });
    }
  }
  // widget got hidden with the custom logic added on render function
  unhideWidget();
}
